"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlTabLayout", function ($route, $location, $pageRouter, routeUtils, directiveUtils) {
  var defaultConfig = {
    tabsetClass: "tl-tab-layout",
    pillsClass: "tl-layout-nav",
    pillDirective: "tlTabLayoutPillDefaultContent",
    tabParameter: "tab",
    tabs: []
  };
  return {
    restrict: "E",
    replace: true,
    scope: true,
    controllerAs: "tabLayoutCtrl",
    template: '' + '<div class="ts-tabset">' + '   <div class="ts-tab-pills">' + '<div class="display-ib" ng-if="hasPrevious() || hasNext()" style="min-width: 40px"> ' + '<div class="display-ib" ng-click="previous()"><i class="fa fa-caret-left pill-previous fa-2x align-middle" ng-class="{\'darkBlue\':hasPrevious(), \'grey\':!hasPrevious()}"></i></div>' + ' <div  class="display-ib" ng-click="next()"><i class="fa fa-caret-right pill-next fa-2x align-middle" ng-class="{\'darkBlue\':hasNext() , \'grey\':!hasNext()}"></i></div>' + '</div>' + '       <tl-tab-layout-pill ng-repeat="tab in tabLayoutCtrl.tabs | filter: { visible: true } track by tabLayoutCtrl.getTabId(tab)"></tl-tab-layout-pill>' + "<div ng-if=\"reportPageCtrl.isEditing() && tabLayoutCtrl.getConfig().section===true\" tl-tooltip=\"Cr\xE9er une nouvelle section\" class=\"tl-panel-menu edition-section\" ng-click=\"reportPageCtrl.createSection()\">\n                <i class=\"fa fa-plus fa-2x\"></i>\n            </div>" + '   </div>' + '   <div class="ts-tab-contents tl-layout-content">' + '       <tl-tab-layout-content ng-repeat="tab in tabLayoutCtrl.tabs track by tabLayoutCtrl.getTabId(tab)"></tl-tab-layout-content>' + '   </div>' + '</div>',
    link: function link($scope, $el, $attrs, ctrl) {
      var unwatch = $attrs.$observe("config", function (configProp) {
        unwatch();
        $scope.$parent.$watch(configProp, function (config) {
          if (config == null) {
            return;
          }
          // TODO : check if re-init is working ( config change )
          ctrl.initialize(config);
        });
      });
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        selectedTabId = null,
        config = null,
        section = null,
        initialRoute = $pageRouter.getCurrentRoute(),
        // index du premier tab visible
        firstTabIdx = 0;
      ctrl.tabs = [];
      ctrl.initialize = function (_config) {
        config = _.extend(angular.copy(defaultConfig), _config);
        if (config.tabsetId) {
          $scope.$on("tabset:" + config.tabsetId + ":select-tab", function (e, tabId) {
            ctrl.selectTabById(tabId);
          });
        }
        $element.addClass(config.tabsetClass);
        $element.find(".ts-tab-pills").addClass(config.pillsClass);
        var sectionParam = config.tabParameter || "tab",
          initialTabFragment = initialRoute.params[sectionParam],
          path = initialRoute.$$route.originalPath,
          routeSectionRegexp = new RegExp("^.*[\/]:" + sectionParam + "[?]?"),
          sectionParams = _.omit(initialRoute.params, sectionParam);
        section = routeSectionRegexp.exec(path)[0];
        section = routeUtils.replaceParams(section, sectionParams);
        var unregisterLocationHandler = $pageRouter.registerLocationHandler(section, function (newParams) {
          var tabId = newParams[sectionParam];
          ctrl.selectTabById(tabId);
        });
        $scope.$on("$destroy", unregisterLocationHandler);
        $scope.$watchCollection(function () {
          return config.tabs;
        }, function (newTabs, oldTabs) {
          if (newTabs === oldTabs) {
            return;
          }
          onConfigTabChange(newTabs, false);
        });
        onConfigTabChange(config.tabs, true);
        if (ctrl.tabs.length > 0) {
          var initialTab = initialTabFragment && _.find(ctrl.tabs, {
            fragment: initialTabFragment
          }) || ctrl.tabs[0];
          ctrl.selectTab(initialTab, true);

          // reaffiche le tab si iil n'est pas visible par défaut
          var indexInitialTab = _.indexOf(ctrl.tabs, initialTab);
          if (config.max && (indexInitialTab < firstTabIdx || indexInitialTab >= firstTabIdx + config.max)) {
            firstTabIdx = indexInitialTab - (config.max - 1);
            if (firstTabIdx < 0) {
              firstTabIdx = 0;
            }
          }
          ctrl.updateVisibility();
        }
      };
      function onConfigTabChange(newTabs, initial) {
        if (config.tabMapper) {
          ctrl.tabs = _.map(newTabs, config.tabMapper);
        } else {
          ctrl.tabs = newTabs;
        }
        ctrl.updateVisibility();

        // check if there should be an active tab id change.
        var nextTabId = null;
        if (ctrl.tabs.length === 0) {
          nextTabId = null;
        } else {
          if (nextTabId == null) {
            nextTabId = getTabId(ctrl.tabs[0]);
          } else {
            var tabIds = _.map(ctrl.tabs, getTabId);
            if (!_.includes(tabIds, selectedTabId)) {
              nextTabId = tabIds[0];
            }
          }
        }
        if (nextTabId !== selectedTabId) {
          ctrl.selectTabById(nextTabId, initial);
        }
      }
      function getTabId(tab) {
        return tab.fragment; // TODO : stuff here ?
      }
      ctrl.getTabId = function (tab) {
        return getTabId(tab);
      };
      ctrl.isSelectedTab = function (tab) {
        return getTabId(tab) === selectedTabId;
      };
      ctrl.getSelectedTabId = function () {
        return selectedTabId;
      };
      ctrl.getConfig = function () {
        return config;
      };
      ctrl.getParentParameters = function () {
        var parameters = {};
        var parentTabset = directiveUtils.getParentController($element, "tlTabLayout");
        var parentTab = directiveUtils.getParentController($element, "tlTabLayoutContent");
        if (parentTabset && parentTab) {
          var paramName = parentTabset.getConfig().tabParameter;
          var paramValue = parentTab.getFragment();
          parameters[paramName] = paramValue;
          _.extend(parameters, parentTabset.getParentParameters());
        }
        return parameters;
      };
      ctrl.selectTabById = function (tabId, noUrlChange) {
        var selected = _.find(ctrl.tabs, function (tab) {
          return getTabId(tab) === tabId;
        });
        if (selected) {
          ctrl.selectTab(selected, noUrlChange);
        }
      };
      ctrl.changeUrl = function (tab) {
        // replaces :params with actual values.
        var params = ctrl.getParentParameters();
        params[config.tabParameter] = tab.fragment;
        var tabUrl = routeUtils.replaceParams(section, params);
        $location.path(tabUrl);
      };
      ctrl.selectTab = function selectTab(tab, noUrlChange) {
        selectedTabId = getTabId(tab);
        if (config.onTabChange) {
          config.onTabChange(tab);
        }
        _.each(ctrl.tabs, function (tab) {
          tab.active = false;
        });
        tab.active = true;
        if (!noUrlChange) {
          ctrl.changeUrl(tab);
        }
      };
      ctrl.updateVisibility = function () {
        for (var i = 0; i < ctrl.tabs.length; i++) {
          if (i < firstTabIdx) {
            // si le tab est actif alors on le desactive
            if (ctrl.tabs[i].active) {
              if (i - 1 >= firstTabIdx) {
                ctrl.changeUrl(ctrl.tabs[i - 1]);
              } else {
                ctrl.changeUrl(ctrl.tabs[i + 1]);
              }
            }
            ctrl.tabs[i].visible = false;
          } else {
            ctrl.tabs[i].visible = true;
          }
        }
      };
      $scope.hasNext = function () {
        var nextTab = firstTabIdx + (config ? config.max : 100);
        return nextTab < ctrl.tabs.length;
      };
      $scope.next = function () {
        if ($scope.hasNext()) {
          firstTabIdx++;
          ctrl.updateVisibility();
        }
      };
      $scope.hasPrevious = function () {
        return firstTabIdx > 0;
      };
      $scope.previous = function () {
        if ($scope.hasPrevious()) {
          firstTabIdx--;
          ctrl.updateVisibility();
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/tabset/tlTabLayout.js
// module id = 3008
// module chunks = 13